module.exports = __webpack_public_path__ + "img/89520e3.png";